/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import LettersIcon from 'icons/LettersIcon';

const messages = defineMessages({
  title: {id: 'navigation.reports.letters'},
});

const LettersItem = () => (
  <RouteLinkItem
    iconBefore={LettersIcon}
    route="midas/reports/letters"
    title={messages.title}
  />
);

export default LettersItem;
